import { useTranslation } from "react-i18next";
import Card from "../shared/Card/Card";
import { IVehicle } from "../../models/Vehicle";
import LoadingWheel from "../shared/LoadingWheel";
import useJobsByVehicle from "../../data/useJobsByVehicle";
import JobOverviewCard from "../jobs/JobOverviewCard";


export default function VehicleJobs({ vehicle }: { vehicle: IVehicle }) {
  const { t } = useTranslation("vehicles");
  const { jobs } = useJobsByVehicle(vehicle.id);

  return (
    <Card title={t("Vehicle Jobs")} bodyClassName="p-4" collapsible>
      <div className="flex flex-col justify-evenly gap-y-2">
        {jobs.isLoading ? <LoadingWheel /> : jobs?.data?.data.map((job) => (
          <JobOverviewCard key={job.id} job={job} jobPartCategories={job.jobPartCategories} showView />
        ))}
      </div>
    </Card>
  );
};